export type JsonRecord = Record<string, unknown>;

export function isRecord(value: unknown): value is JsonRecord {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function describeShape(value: unknown): string {
  if (value == null) return String(value);
  if (Array.isArray(value)) return `array(len=${value.length})`;
  if (typeof value === 'object')
    return `object(keys=${Object.keys(value as object)
      .slice(0, 12)
      .join(',')}${Object.keys(value as object).length > 12 ? ',…' : ''})`;
  return typeof value;
}

export function requireRecord(value: unknown, context: string): JsonRecord {
  if (!isRecord(value)) {
    throw new Error(`${context}: expected object, got ${describeShape(value)}`);
  }
  return value;
}

export function requireArray(value: unknown, context: string): unknown[] {
  if (!Array.isArray(value)) {
    throw new Error(`${context}: expected array, got ${describeShape(value)}`);
  }
  return value;
}

export function requireArrayKey(obj: unknown, key: string, context: string): unknown[] {
  const record = requireRecord(obj, context);
  return requireArray(record[key], `${context}: invalid "${key}"`);
}
